builder_configuration = [
  {
    'sku'         : 'PASTE',
    'model-file'  : 'PASTE',
    'type'        : 'PASTE',
    'ghost-image' : 'PASTE',
  },
  {
    'sku':        'CH-Apollo-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Apollo-YG_R3.glb?v=1600448499',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Apollo-YG_200x200_f76c2735-cf49-4aef-8cf2-408ac253b5d5.png?v=1600453963',
  },
  {
    'sku':        'CH-BabyFeet-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-BabyFeet-SS_R3.glb?v=1600448496',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Baby-Feet-Charm_SS_200x200_9860ade4-24b9-4eeb-b790-ed1fa7d91af6.png?v=1600453963',
  },
  {
    'sku':        'CH-Bee-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Bee-SS_R5.glb?v=1600448495',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Bee_SS_200x200_eba49a1b-b968-4388-a5b7-79c5a19c498c.png?v=1600453963',
  },
  {
    'sku':        'CH-BlueSun-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Blue_Sun-YG_R9.glb?v=1601488986',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Sun_Blue-YG_200x200_6245ff87-16ee-4004-a3d1-6e1df8686891.png?v=1600453963',
  },
  {
    'sku':        'CH-CarpeFob-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CarpeFob-SS_R2.glb?v=1600448494',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CarpeFob-SS_200x200_bce1dcf4-7a9b-414f-943e-3bfd2c621bd4.png?v=1600453963',
  },
  {
    'sku':        'CH-CarpeFob-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CarpeFob-YG_R2.glb?v=1600448495',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CarpeFob-YG_200x200_6b7bf119-8953-4212-9b66-b4fc515d327b.png?v=1600453963',
  },
  {
    'sku':        'CH-Case-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Case-SS_R2.glb?v=1603394393',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Oval-Half_SS_200x200_edec9052-0db8-4edb-b447-b2c563da8e6d.png?v=1600454196',
  },
  {
    'sku':        'CH-Case-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Case-YG_R1.glb?v=1600451853',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Oval-Half_YG_200x200_5b50c242-af64-42ff-a979-621f1bd8db90.png?v=1600454222',
  },
  {
    'sku':        'CH-CrossCushion-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CrossCushion-SS_R4.glb?v=1600448495',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Cross-Cushion_SS_200x200_235f4482-86d7-407b-a42d-d484414b8961.png?v=1600453963',
  },
  {
    'sku':        'CH-CrossRound-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Cross_Round-YG_R1.glb?v=1598623823',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Cross-Round_YG_200x200_eb338027-94b0-48a0-8be5-7ef55fa3ddc3.png?v=1598623539',
  },
  {
    'sku':        'CH-DiamondDisc-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-DiamondDisc-YG_R1.glb?v=1600450723',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-DiamondDisc-YG_200x200_df60ca33-ceb3-4ab2-b345-382b58d7cba5.png?v=1600453963',
  },
  {
    'sku':        'CH-Dragonfly-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Dragonfly-SS_R3.glb?v=1600448457',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Dragonfly_SS_200x200_1ca23d18-f6b8-43da-b349-c16b85be04da.png?v=1600453963',
  },
  {
    'sku':        'CH-Electra-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Electra-YG_R1.glb?v=1598623823',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Electra-YG_200x200_bd7b9b54-d3ca-43e0-b6cd-30bf7328a9b3.png?v=1598623539',
  },
  {
    'sku':        'CH-Floral-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Floral-SS_R4.glb?v=1603394392',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Floral_SS_200x200_b34fa07f-f3f4-45c3-b89f-8bcf23eddde5.png?v=1600453963',
  },
  {
    'sku':        'CH-Floral-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Floral-YG_R3.glb?v=1600448457',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Floral_YG_200x200_dfa29b72-3fbc-46a1-96ae-e7e28355450b.png?v=1600453963',
  },
  {
    'sku':        'CH-GlobalCompass-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-GlobalCompass-SS_R4.glb?v=1603394391',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Global-Compass_SS_200x200_54bd191e-a1ee-42db-806e-5a32b8182c67.png?v=1600453963',
  },
  {
    'sku':        'CH-LapisKey-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LapisKey-YG_R4.glb?v=1600449370',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-LapisKey-YG_200x200_1d62a861-8f67-45e0-9e71-f5b944792e10.png?v=1600454454',
  },
  {
    'sku':        'CH-LargeMoon-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LargeMoon-SS_R3.glb?v=1600448456',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-LargeMoon-SS_200x200_b0f9a3af-de94-4fc7-9a35-6e4bf7ce1865.png?v=1600454454',
  },
  {
    'sku':        'CH-LuckyClover-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LuckyClover-SS_R4.glb?v=1603394393',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-LuckClover-SS_200x200_285642b9-a212-4146-847e-c8d8699875a8.png?v=1600454454',
  },
  {
    'sku':        'CH-MessageBox-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MessageBox-YG_R5.glb?v=1600449772',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MessageBox-HP_200x200_95e72004-9745-45c9-92d3-d5857c357a39.png?v=1600454454',
  },
  {
    'sku':        'CH-MiniCompass-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniCompass-SS_R5.glb?v=1603394390',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniCompass-SS_200x200_c0147363-f445-42ab-88cc-ec4ffc3db166.png?v=1600454454',
  },
  {
    'sku':        'CH-NeverFearFob-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-NeverFear-SS_R3.glb?v=1603394390',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-NeverFearFob-SS_200x200_1c37699c-3d6f-44a3-9a19-ba2b88a2e2dd.png?v=1600454454',
  },
  {
    'sku':        'CH-NeverFearFob-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-NeverFear-YG_R2.glb?v=1600448456',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-NeverFearFob-YG_200x200_afe3a162-037c-41ec-a5b6-41afbd697e78.png?v=1600454454',
  },
  {
    'sku':        'CH-OvalFour-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-OvalFour-SS_R3.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-OvalFour-SS_200x200_09e50f71-9c79-496f-aec4-8f436f5729e9.png?v=1600454777',
  },
  {
    'sku':        'CH-OvalLocket-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-OvalLocket-YG_R3.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Oval-Locket-YG_200x200_7ee2614d-2d1c-4753-85d0-44ef27752c77.png?v=1600454777',
  },
  {
    'sku':        'CH-OvalPinstripe-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-OvalPinstripe-SS_R4.glb?v=1600452699',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-OvalPinstripe-SS_200x200_7e886b61-7b27-49de-8440-9bd856fe993a.png?v=1600454777',
  },
  {
    'sku':        'CH-PinstripeLocket-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-PinstripeLocket-SS_R4.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-PinstripeLocket-SS_200x200_9a6b0f91-8cc0-404b-817a-57faf72c23d9.png?v=1600454777',
  },
  {
    'sku':        'CH-Poseidon-TT',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Poseidon-TT_R2.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Poseidon-TT_200x200_16e9ffb2-5535-4b24-bc87-365a1392e14c.png?v=1600454777',
  },
  {
    'sku':        'CH-Power-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Power-YG_R8.glb?v=1601488986',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Power-YG_200x200_314062f2-bd54-492f-8fba-0e23d3d36070.png?v=1600454777',
  },
  {
    'sku':        'CH-SapphireLocket-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SapphireLocket-SS_R1.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Sapphire-Locket-SS_200x200_72189f5c-af6e-4d58-9c16-098796b7ac30.png?v=1600454777',
  },
  {
    'sku':        'CH-SmallBabyFeet-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmBabyFeet-SS_R4.glb?v=1600452699',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Baby-Feet-Small-Charm_SS_200x200_aeefaa73-43e5-42c6-8f2f-34b1e8b1e7cb.png?v=1600454777',
  },
  {
    'sku':        'CH-SmallBabyFeet-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmBabyFeet-YG_R4.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Baby-Feet-Small-Charm_200x200_2c4d0502-02b5-46f1-a80a-53eb17d989c6.png?v=1600454777',
  },
  {
    'sku':        'CH-SmallPawPrint-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmPawPrint-SS_R4.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Paw-Print-Small-Charm_SS_200x200_2efa4fd3-a7dc-4e65-8be4-0251c146d97f.png?v=1600454777',
  },
  {
    'sku':        'CH-SmallPawPrint-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmPawPrint-YG_R3.glb?v=1600452698',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Paw-Print-Small-Charm_YG_200x200_28dcee4f-7c51-42df-8acf-1199a08cc60b.png?v=1600454777',
  },
  {
    'sku':        'CH-SmEye-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmEye-YG_R5.glb?v=1600453108',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Eye-Small_YG_200x200_6c4be35b-3342-4f5d-af44-4c7987540345.png?v=1600456066',
  },
  {
    'sku':        'CH-SmLove-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmLove-SS_R4.glb?v=1600453327',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Love-Small_SS_200x200_62f76680-8620-438f-8940-2c12ebf332a5.png?v=1600455994',
  },
  {
    'sku':        'CH-SMLove-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmLove-YG_R2.glb?v=1600453109',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Love-Small_YG_200x200_485ec02e-046e-4184-8a02-7708dadc819d.png?v=1600455994',
  },
  {
    'sku':        'CH-Sun-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Sun-YG_R2.glb?v=1600453107',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Sun-YG_200x200_4e70818a-4790-4a51-b8d0-7b044cc125d1.png?v=1600455994',
  },
  {
    'sku':        'CH-Telescope-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Telescope-SS_R3.glb?v=1600453107',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Telescope-SS_200x200_f0e769fc-aa63-4ca9-a018-d0403bff3cf9.png?v=1600455994',
  },
  {
    'sku':        'CH-Telescope-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Telescope-YG_R3.glb?v=1600453107',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Telescope-YG_200x200_70e87079-4260-4a24-8222-1829ef315117.png?v=1600455994',
  },
  {
    'sku':        'CH-TimeWhite-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-TimeWhite-YG_R4.glb?v=1600453450',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-TimeWhite-YG_200x200_987a12e9-5347-4f1d-8111-78d7205f335f.png?v=1600455994',
  },
  {
    'sku':        'TT-PetiteHeart',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-PetiteHeart-TT_R3.glb?v=1600453106',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Heart-Petite_200x200_2ee60b67-f698-4306-b5f2-27fe3187d70c.png?v=1600455994',
  },
  {
    'sku':        'TT-StripedCase',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-StripedCase-TT_R1.glb?v=1598623823',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Striped-Case_200x200_1883a685-ce03-4666-9e8a-9444c9000d9c.png?v=1598623539',
  },
  {
    'sku':        'CH-PaveBee-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-PaveBee-YG_R5.glb?v=1600453108',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-PaveBee_YG_200x200_c9161d2f-5ce3-428f-a195-9603b18e5a1a.png?v=1600455994',
  },
  {
    'sku':        'CH-PaveCompass-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-PaveCompass-YG_R7.glb?v=1600453109',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-PaveCompass_YG_200x200_ccd566c7-fcac-4428-9dc5-852bd35b3fe9.png?v=1600455994',
  },
  {
    'sku':        'CH-CushionLocket-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CushionLocket-SS_R1.glb?v=1598623823',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CushionLocket-SS_200x200_1f35cc78-fb14-4f1f-aad9-094f949b1a6f.png?v=1598623539',
  },
  {
    'sku':        'CH-CushionLocket-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CushionLocket-YG_R1.glb?v=1598623823',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CushionLocket-YG_200x200_0fb8c45f-1e84-4b82-bb10-41543372ebaf.png?v=1598623539',
  },
  {
    'sku':        'CH-CompassBlue-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CompassBlue-YG_R1.glb?v=1600453107',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CompassBlue_YG_200x200_3dd6ba32-11b5-4295-a2e1-e40185636d8d.png?v=1600455994',
  },
  {
    'sku':        'CH-CarpeDiem-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Carpe_Diem-YG_R4.glb?v=1600876011',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Carpe-Diem-Small-YG_200x200_dbaf3d1c-da66-4d73-96b4-34bd78597a8f.png?v=1600876885',
  },
  {
    'sku':        'CH-BabyFeet-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-BabyFeet-YG_R3.glb?v=1600876015',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Baby-Feet-Charm_YG_200x200_31fb898c-697c-48d1-ac26-93340bad8815.png?v=1600876885',
  },
  {
    'sku':        'CH-Constellation-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Constellation-YG_R4.glb?v=1600876018',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Constellation_YG_200x200_1e83c727-5348-455e-a09b-5122e669ec78.png?v=1600876885',
  },
  {
    'sku':        'CH-DiscFloral-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-DiscFloral-SS_R4.glb?v=1603394391',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Floral_SS_200x200_63d5fe46-70a6-4f44-8ce6-55a3fe63f1cd.png?v=1600876885',
  },
  {
    'sku':        'CH-DiscFloral-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-DiscFloral-YG_R5.glb?v=1600876016',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Floral_YG_200x200_69ea1808-8748-457d-a9cc-8f5ee7e6a300.png?v=1600876885',
  },
  {
    'sku':        'CH-XLCarpeDiem-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-XLCarpeDiem-YG_R3.glb?v=1600876013',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-XLCarpe-Diem-YG_200x200_3cc35dc3-50b1-453e-8d3f-f39db8896384.png?v=1600876885',
  },
  {
    'sku':        'CH-SmEye-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmEye-SS_R5.glb?v=1600876015',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Eye-Small_SS_200x200_6c57ebaa-0104-4da6-897b-bd919cfbb554.png?v=1600876885',
  },
  {
    'sku':        'CH-MiniCarpeDiem-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniCarpe-SS_R5.glb?v=1603394391',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniCarpe-SS_200x200_d5b54b02-5f2a-4b1c-b43b-00d48f920a00.png?v=1600876885',
  },
  {
    'sku':        'CH-MiniCarpeDiem-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniCarpe-YG_R5.glb?v=1600876014',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniCarpe-YG_200x200_00a2e620-f1fa-4a25-8069-f41db3d6dcdf.png?v=1600876885',
  },
  {
    'sku':        'CH-PaveLock-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-PaveLock-SS_R3.glb?v=1600876013',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Pave-Lock-SS_200x200_0a10a679-fbd5-4bd2-abba-12dd83bc07c3.png?v=1600876885',
  },
  {
    'sku':        'CH-OvalStar-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-OvalStar-SS_R4.glb?v=1600876012',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-OvalStar-SS_200x200_2df5fa16-53ee-481c-b81f-58bd76e4bf8f.png?v=1600876885',
  },
  {
    'sku':        'CH-OvalStar-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-OvalStar-YG_R4.glb?v=1600876012',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-OvalStar-YG_200x200_cd0156ca-e389-49ba-ae01-4743a646aa07.png?v=1600876885',
  },
  {
    'sku':        'CH-Mosaic-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Mosaic-SS_R7.glb?v=1600877403',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Mosaic-SS_200x200_340e5fd9-eba8-487c-804c-07f8a38d5cce.png?v=1600877817',
  },
  {
    'sku':        'CH-Mosaic-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Mosaic-YG_R6.glb?v=1600877404',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Mosaic-YG_200x200_9fef5942-7c4b-4c5e-a050-3542dae6e56b.png?v=1600877817',
  },
  {
    'sku':        'TT-PaveMoon',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-TT-PaveMoon_R4.glb?v=1600877406',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Pave-Moon_200x200_c630caee-8ac1-41d0-849c-27991181effd.png?v=1600877817',
  },
  {
    'sku':        'CH-MyEarth-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MyEarth-SS_R4.glb?v=1600877405',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Earth-SS_200x200_d4b76792-d7e0-40f9-bf59-bae8a4ef2285.png?v=1600877817',
  },
  {
    'sku':        'CH-SnakeMed-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SnakeMed-YG_R2.glb?v=1600877438',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SnakeMed_YG_200x200_5d1a2cd7-ca41-4549-bae1-e3f4f1e16f4c.png?v=1600877817',
  },
  {
    'sku':        'TT-SnakeMed',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-TT-SnakeMed_R11.glb?v=1603394392',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-SnakeMed_200x200_c75b670e-7bd0-4006-883d-9faab9335484.png?v=1600877817',
  },
  {
    'sku':        'CH-Ham-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Ham-YG_R4.glb?v=1600877404',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Ham_YG_200x200_6fbf5f97-953d-4de7-8887-34fe7a9950ba.png?v=1600877817',
  },
  {
    'sku':        'CH-Moon-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Moon-YG_R4.glb?v=1600974225',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Moon-YG_200x200_63ef4e6e-53ba-4877-bdfd-fbe72c362c69.png?v=1600974877',
  },
  {
    'sku':        'CH-Power-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Power-SS_R10.glb?v=1604421944',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Power-SS_200x200_22ab556c-0ae6-4112-a412-59867a0b2064.png?v=1600974877',
  },
  {
    'sku':        'CH-SMS-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SMS-SS_R10.glb?v=1600974232',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SMS-SS_200x200_880d75cd-bf4b-4663-8690-7c015fe18ec5.png?v=1600974877',
  },
  {
    'sku':        'CH-SMS-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SMS-YG_R5.glb?v=1600974232',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SMS-YG_200x200_ba51e066-ef25-41b4-af08-9d70f0e685f6.png?v=1600974877',
  },
  {
    'sku':        'CH-TimeBlue-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-TimeBlue-YG_R2.glb?v=1600974224',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-TimeBlue-YG_200x200_fe02d82a-9b92-412c-bbfd-d7ea89a7c917.png?v=1600974877',
  },
  {
    'sku':        'TT-Love',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-TT-Love_R16.glb?v=1600974232',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Love_200x200_2753d777-bf24-47e3-9d23-83bd6a1fefb5.png?v=1600974877',
  },
  {
    'sku':        'TT-MySMS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-TT-MySMS_R8.glb?v=1603394392',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-MySMS_200x200_e5b32928-4764-472d-af76-800bbcb39948.png?v=1600974877',
  },
  {
    'sku':        'CH-BeeWhite-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-BeeWhite-YG_R8.glb?v=1600974225',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-BeeWhite_YG_200x200_f7ac6b13-b73c-4e88-9f6d-cbacecaa9d98.png?v=1600974877',
  },
  {
    'sku':        'CH-CompassWhite-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CompassWhite-YG_R6.glb?v=1600974234',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CompassWhite_YG_200x200_3aee851c-9268-4727-8523-66fa8b5c65a4.png?v=1600974877',
  },
  {
    'sku':        'CH-Apollo-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Apollo-SS_R3.glb?v=1600974235',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Apollo-SS_200x200_977569c5-2686-4fca-abe9-6c572725762d.png?v=1600974877',
  },
  {
    'sku':        'CH-SmMosaic-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmMosaic-SS_R7.glb?v=1600877405',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Mosaic_Small-SS_200x200_2fcc025f-78d3-44ec-803a-7c962456cd95.png?v=1600974877',
  },
  {
    'sku':        'CH-SmMosaic-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmMosaic-YG_R7.glb?v=1600877405',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Mosaic_Small-YG_200x200_6299ca10-5659-48ee-af2b-6bdee972e1bf.png?v=1600974877',
  },
  {
    'sku':        'CH-GlobalCompass-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-GlobalCompass-YG_R6.glb?v=1601489813',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Global-Compass_YG_200x200_9f704604-ea16-4ddf-a529-4664fbcaaf0b.png?v=1601490206',
  },
  {
    'sku':        'CH-MiniCompass-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniCompass-YG_R5.glb?v=1601489803',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniCompass-YG_200x200_772229a9-38a3-4454-9080-279aa54601f1.png?v=1601490205',
  },
  {
    'sku':        'CH-XLCarpeDiem-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-XLCarpeDiem-SS_R9.glb?v=1603394390',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-XLCarpe-Diem-SS_200x200_48b3a41b-dfb3-4766-a90b-56d2919f2728.png?v=1601490205',
  },
  {
    'sku':        'CH-LgDisc-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LgDisk-SS_R7.glb?v=1603394393',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-VineHalf_SS_200x200_e4497167-4f56-4340-8b7e-7fc31f244d2c.png?v=1601490301',
  },
  {
    'sku':        'CH-LgDisc-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LG-Disc-YG_R7.glb?v=1601489824',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-VineHalf_200x200_f413e10e-0af9-4b66-afc3-91141ef1f04c.png?v=1601490301',
  },
  {
    'sku':        'CH-SmApollo-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmApollo-SS_R6.glb?v=1601489815',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Apollo-Small-Charm_SS_200x200_638bdd95-c1a5-4047-886f-06cdad724ea8.png?v=1601490205',
  },
  {
    'sku':        'CH-SmApollo-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmApollo-YG_R7.glb?v=1601489815',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Apollo-Small-Charm_YG_200x200_0c688578-5570-41cb-8d75-794f86d29ad9.png?v=1601490205',
  },
  {
    'sku':        'CH-SmCompass-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmCompass-SS_R12.glb?v=1603394391',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CompassSmall_SS_200x200_269f3b6b-1a9f-45a5-ba3e-86e8deb1986a.png?v=1601490205',
  },
  {
    'sku':        'CH-SmCompass-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmCompass-YG_R6.glb?v=1601489810',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CompassSmall_YG_200x200_23b69e88-e3b3-4ed3-a97a-2714f1bec4db.png?v=1601490205',
  },
  {
    'sku':        'TT-Eye',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-TT-Eye_R9.glb?v=1601489814',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Eye_200x200_29effee8-5b2f-457d-8d89-e98f5d17df5a.png?v=1601490206',
  },
  {
    'sku':        'CH-Earth-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Earth-YG_R5.glb?v=1601489809',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Earth-YG_200x200_149763d7-0bbe-4ae1-9ac5-141642fcd802.png?v=1601490205',
  },
  {
    'sku':        'CH-Moon-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Moon-SS_R3.glb?v=1600974224',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Moon-SS_200x200_5333b7ca-42d7-41ab-a1a6-834a00ec30fc.png?v=1601490205',
  },
  {
    'sku':        'CH-Athena-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Athena-YG_R2.glb?v=1601489807',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Athena_YG_200x200_5bbe01a7-52ce-4c75-a4b3-ddaf3951e862.png?v=1601490205',
  },
  {
    'sku':        'CH-Bee-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Bee-YG_R2.glb?v=1601489808',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Bee_YG_200x200_9f2e4ccf-6b5d-4606-b450-d521dabe058e.png?v=1601490205',
  },
  {
    'sku':        'CH-SmSnake-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmSnake-YG_R11.glb?v=1616611221',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SmSnake-YG_200x200_aaa7216e-85f2-4161-bd4c-bf89b18fbc5b.png?v=1616611250',
  },
  {
    'sku':        'TT-SmSnake',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmSnake-TT_R7.glb?v=1616611221',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-SmSnake_200x200_1f1759a9-8803-4305-a21c-836106f7fc69.png?v=1616611250',
  },
  {
    'sku':        'CH-Think-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Think-SS_R4.glb?v=1616611220',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Think-SS_200x200_16b1adf2-6801-4892-a274-bd2ce1458edd.png?v=1616611250',
  },
  {
    'sku':        'CH-Think-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Think-YG_R16.glb?v=1616611220',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Think-YG_200x200_ad520226-725a-4711-a1d7-aebcb3809260.png?v=1616611250',
  },
  {
    'sku':        'CH-SmVenus-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmVenus-YG_R5.glb?v=1616611221',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SmVenus-YG_200x200_477fefbe-0e1a-4b32-a820-8b81055d6e7b.png?v=1616611250',
  },
  {
    'sku':        'CH-SmDragonfly-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmDragonfly-YG_R3.glb?v=1616611220',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SmDragonfly-YG_200x200_eb2675fa-b3e2-455b-b02a-c51965465513.png?v=1616611250',
  },
  {
    'sku':        'CH-PowerSaph-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-PowerSaph-SS_R6.glb?v=1616611218',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-PowerSaph-SS_200x200_9e642c9d-7683-414f-9419-c0f8706a00cb.png?v=1616611250',
  },
  {
    'sku':        'CH-PowerDiam-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-PowerDiam-YG_R14.glb?v=1616611218',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-PowerDiam-YG_200x200_a9352f9e-8bdb-4c4b-b5d7-81a66446e3d3.png?v=1616611250',
  },
  {
    'sku':        'CH-Iris-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Iris-YG_R5.glb?v=1616611221',
    'type': 'Charm',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Iris-YG_200x200_450edfc0-5ce9-492f-8fca-2f188034e595.png?v=1616611250',
  },
  {
    'sku'         : 'CH-SmDragonfly-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmDragonfly-SS_R1.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SmDragonfly-SS_200x200_7fea2d39-1a36-4fae-8e7a-725683063389.png?v=1629316859',
  },
  {
    'sku'         : 'CH-DiamCross-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-DiamCross-YG_R4.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-DiamCross-YG_200x200_498ceead-6f01-43b6-9df3-7ac1adbb3ee5.png?v=1629316858',
  },
  {
    'sku'         : 'CH-SaphCross-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SaphCross-SS_R7.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SaphCross-SS_200x200_36ad3525-cfd0-4226-be7f-0b922e4cdc49.png?v=1629316858',
  },
  {
    'sku'         : 'CH-CompassMed-SS-Blue',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CompassMed-Blue-SS_R19.glb?v=1629816575',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CompassMed-SS-Blue_200x200_ab48797f-d1c8-45e0-aa8d-64b779e3556f.png?v=1629316858',
  },
  {
    'sku'         : 'CH-CompassMed-SS-White',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CompassMed-White-SS_R8.glb?v=1629816575',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CompassMed-SS-White_200x200_810f60c0-dc8b-400b-b9e1-8b32c458ad83.png?v=1629316858',
  },
  {
    'sku'         : 'CH-CompassMed-YG-White',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CompassMed-White-YG_R6.glb?v=1629816575',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CompassMed-YG-White_200x200_61ed07d0-7b89-4051-b930-45e52fd93af4.png?v=1629316858',
  },
  {
    'sku'         : 'CH-LgCompass-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LgCompass-SS_R6.glb?v=1629816575',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-LGcompass-SS_200x200_53ea6f7a-cefe-488f-8cc4-57c7e9cb9b49.png?v=1629316858',
  },
  {
    'sku'         : 'CH-CarpeWhite-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-CarpeWhite-SS_R2.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-CarpeWhite-SS_200x200_a48213c2-3a5a-44d0-aba6-fa58afe2ac10.png?v=1629316858',
  },
  {
    'sku'         : 'CH-BlueStar-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-BlueStar-SS_R3.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-BlueStar-SS_200x200_4559e3ee-4616-4953-889a-57f03c15070b.png?v=1629316858',
  },
  {
    'sku'         : 'CH-LGStar-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LgStar-SS_R2.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-LgStar-SS_200x200_ca7903d6-ed5e-44b6-958b-f36aa75cad53.png?v=1629316858',
  },
  {
    'sku'         : 'CH-Buckle-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Buckle-SS_R2.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Buckle-SS_200x200_556e3870-8953-4b54-b050-e311738d8687.png?v=1629316858',
  },
  {
    'sku'         : 'TT-Buckle',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Buckle-TT_R1.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/TT-Buckle_200x200_9429c810-86ef-4705-90d7-31f60ea9536f.png?v=1629316858',
  },
  {
    'sku'         : 'CH-MiniBlue-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniBlue-YG_R5.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniBlue-YG_200x200_a8246732-13a0-4cc5-9b96-7693d07fdc00.png?v=1629316858',
  },
  {
    'sku'         : 'CH-MiniGreen-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniGreen-YG_R2.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniGreen-YG_200x200_afe262fc-c08e-49cd-b4f7-79c5e737f320.png?v=1629316858',
  },
  {
    'sku'         : 'CH-MiniRuby-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniRuby-YG_R3.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniRuby-YG_200x200_132bce33-eeb9-4b59-811f-4d52a3e06d34.png?v=1629316858',
  },
  {
    'sku'         : 'CH-DiamPendant-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-DiamPendant-YG_R4.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-DiamPendant-YG_200x200_64ce266b-7280-41b5-a57e-c2713ecaea14.png?v=1629316858',
  },
  {
    'sku'         : 'CH-MiniMoon-YG-Blue',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniMoon-YG_R3.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniMoon-YG-Blue_200x200_941b8833-c614-4291-8e06-bdecff2d748a.png?v=1629316858',
  },
  {
    'sku'         : 'CH-MiniTopaz-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniTopaz-YG_R2.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniTopaz-YG_200x200_86bcb149-c78c-4215-99f4-771ca4ef79c1.png?v=1629316858',
  },
  {
    'sku'         : 'CH-MiniPras-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-MiniPras-YG_R5.glb?v=1629316244',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-MiniPras-YG_200x200_62f61145-1adb-4bf3-b8f3-e1ad396a0be4.png?v=1629316858',
  },
  {
    'sku'         : 'CH-Way-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Way-YG_R2.glb?v=1643645374',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Way-YG_200x200_dd0ff64d-2a97-4448-a888-128358c5b521.png?v=1643645389',
  },
  {
    'sku'         : 'CH-Way-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Way-SS_R2.glb?v=1643645374',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Way-SS_200x200_115a9728-6300-4ca4-8d06-39102b65b315.png?v=1643645389',
  },
  {
    'sku'         : 'CH-Scorpio-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Scorpio-SS_R4.glb?v=1645649724',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Scorpio-SS_200x200_a7a7ce37-4652-483f-9941-01465eb68147.png?v=1645649638',
  },
  {
    'sku'         : 'CH-Scorpio-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Scorpio-YG_R1.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Scorpio-YG_200x200_4117552c-8825-48af-b9f8-bfb063aa7b24.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Aquarius-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Aquarius-YG_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Aquarius-YG_200x200_d7b9742f-dee7-488d-b9ec-8e72bb623d58.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Aquarius-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Aquarius-SS_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Aquarius-SS_200x200_8b53bd51-a104-4351-b867-c82457a39dc9.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Aries-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Aries-YG_R6.glb?v=1645649724',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Aries-YG_200x200_eb4131e7-8869-4be0-8ac7-a59ed4d1f2c4.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Aries-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Aries-SS_R4.glb?v=1645649724',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Aries-SS_200x200_f472e086-ce69-43c0-990b-d217dea1bf9f.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Cancer-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Cancer-YG_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Cancer-YG_200x200_ca8c8b96-664f-4c3e-be05-278f5778cbb8.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Cancer-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm--Cancer-SS_R3.glb?v=1645560549',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Cancer-SS_200x200_4664a0d5-c686-46d3-b0e1-127da81eef09.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Capricorn-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Capricorn-YG_R1.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Capricorn-YG_200x200_3f3440d9-d865-4198-b2ab-db0bf319a388.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Capricorn-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Capricorn-SS_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Capricorn-SS_200x200_fb89d6c0-e013-42cc-a09a-5bb438672650.png?v=1645649642',
  },
  {
    'sku'         : 'CH-Gemini-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Gemini-YG_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Gemini-YG_200x200_b361dbbd-eff9-4d85-abf2-9a9d49668b04.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Gemini-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Gemini-SS_R2.glb?v=1645560549',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Gemini-SS_200x200_5c91c30a-6d67-41e8-8142-c40783af3ae9.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Libra-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Libra-YG_R1.glb?v=1645560596',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Libra-YG_200x200_45470de8-4d58-4ef4-b05c-c68b158dd408.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Libra-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Libra-SS_R2.glb?v=1645560549',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Libra-SS_200x200_76b0c103-39d9-45c6-9d43-601545a1006f.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Leo-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Leo-YG_R1.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Leo-YG_200x200_892d687a-f25a-4a08-a2ba-ef39be84b156.png?v=1645649642',
  },
  {
    'sku'         : 'CH-Leo-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Leo-SS_R1.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Leo-SS_200x200_6665265a-b406-4e83-8db4-98bc4ef8c499.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Pisces-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Pisces-YG_R1.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Pisces-YG_200x200_ae8247a5-afbb-48c7-b6a3-9e7ce75469f6.png?v=1645649638',
  },
  {
    'sku'         : 'CH-Pisces-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Pisces-SS_R3.glb?v=1645649724',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Pisces-SS_200x200_19c39cfc-bf74-4811-bb9f-ac0304c9a2b6.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Taurus-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Taurus-YG_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Taurus-YG_200x200_0c568775-4240-46a9-a51e-aa2562eaa5b8.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Taurus-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Taurus-SS_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Taurus-SS_200x200_5c70030a-c0ac-49cf-aa4e-9592ff273b86.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Sagittarius-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Sagittarius-YG_R4.glb?v=1645560549',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Sagittarius-YG_200x200_d0e5ae92-9579-4261-a923-220799ae06e8.png?v=1645649638',
  },
  {
    'sku'         : 'CH-Sagittarius-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Sagittarius-SS_R4.glb?v=1645560549',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Sagittarius-SS_200x200_d345f5c3-96e1-4c86-b4a7-edc1939cf0ea.png?v=1645649638',
  },
  {
    'sku'         : 'CH-Virgo-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Vergo-YG_R2.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Virgo-YG_200x200_f9d0ca36-1b4b-4ef1-ab62-bcc84cd7eaa8.png?v=1645649637',
  },
  {
    'sku'         : 'CH-Virgo-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Vergo-SS_R5.glb?v=1645560550',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Virgo-SS_200x200_b8fcc45e-6c22-4193-8060-55f93957f3d4.png?v=1645649637',
  },
  {
    'sku'         : 'CH-SunDiam-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm_SunDiam-YG_R19.glb?v=1653480243',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SunDiam-YG.png?v=1653480540',
  },
  {
    'sku'         : 'CH-SunSaph-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm_SunSaph-YG_R4.glb?v=1653480243',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SunSaph-YG.png?v=1653480540',
  },
  {
    'sku'         : 'CH-SunEm-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm_SunEm-YG_R4.glb?v=1653480243',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SunEm-YG.png?v=1653480540',
  },
  {
    'sku'         : 'CH-SunSaph-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm_SunSaph-SS_R4.glb?v=1653480243',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SunSaph-SS.png?v=1653480541',
  },
  {
    'sku'         : 'CH-LGDial-YG-Green',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LGDial-YG-Green_R4.glb?v=1658263695',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-LgDial-YG-Green.png?v=1658263633',
  },
  {
    'sku'         : 'CH-LGDial-YG-White',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-LGDial-YG-White_R4.glb?v=1658263694',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-LgDial-YG-White.png?v=1658263633',
  },
  {
    'sku'         : 'CH-SmDial-YG-Green',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmDial-YG-Green_R7.glb?v=1658263694',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SmDial-YG-Green.png?v=1658263633',
  },
  {
    'sku'         : 'CH-SmDial-YG-White',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-SmDial-YG-White_R6.glb?v=1658263695',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-SmDial-YG-White.png?v=1658263633',
  },
  {
    'sku'         : 'CH-Dandelion-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Dandelion-YG_R4.glb?v=1660739982',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/wish.png?v=1660617136',
  },
  {
    'sku'         : 'CH-Dandelion-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Dandelion-SS_R7.glb?v=1660739982',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/wish-ss.png?v=1660617134',
  },
  {
    'sku'         : 'CH-WiseOwl-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Owl-YG_R3.glb?v=1660739982',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/wise.png?v=1660617135',
  },
  {
    'sku'         : 'CH-WiseOwl-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Owl-SS_R8.glb?v=1660739982',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/wise-ss.png?v=1660617134',
  },
  {
    'sku'         : 'CH-Wolf-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm--Wolf-SS_R3.glb?v=1660739982',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/wild-ss.png?v=1660617134',
  },
  {
    'sku'         : 'CH-Wolf-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Wolf-YG_R3.glb?v=1660739982',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/wild.png?v=1660617134',
  },
  {
    'sku'         : 'CH-Lion-SS',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm--Lion-SS_R4.glb?v=1660739983',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/warrior-ss.png?v=1660617134',
  },
  {
    'sku'         : 'CH-Lion-YG',
    'model-file'  : 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Charm-Lion-YG_R9.glb?v=1660739983',
    'type'        : 'Charm',
    'ghost-image' : 'https://cdn.shopify.com/s/files/1/2143/1049/files/warrior.png?v=1660617134',
  },
  {
    'sku':        'PR-Square-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Square-YG_R3.glb?v=1600879257',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Square_YG_200x200_91b2f0ac-e864-4ff5-a119-a45adac4e99e.png?v=1600879501',
  },
  {
    'sku':        'PR-Strength-TT',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Strength-TT_R7.glb?v=1600879257',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Strength_TT_200x200_be3921bf-6830-4b6c-908a-7daaafa6ea13.png?v=1600879501',
  },
  {
    'sku':        'PR-Heart-TT',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Heart-TT_R6.glb?v=1600879257',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Heart_TT_200x200_71316b60-801f-4642-9f27-383c243e82c1.png?v=1600879501',
  },
  {
    'sku':        'PR-Lining-BLK',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Lining-BLK_R5.glb?v=1600879258',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Lining_BLK_200x200_f549f9e8-e77e-4a4c-ae4e-108eece01208.png?v=1600879502',
  },
  {
    'sku':        'PR-Lining-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Lining-YG_R7.glb?v=1600879258',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Lining_YG_200x200_2d0a0ffc-c5dc-4bda-a58c-bfcad18a7576.png?v=1600879501',
  },
  {
    'sku':        'PR-Pearl-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Pearl_YG_R5.glb?v=1600879257',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Pearl_YG_200x200_baa45fc6-12cd-44bd-b540-3b82724b274b.png?v=1600879502',
  },
  {
    'sku':        'PR-SapphireCab-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy_SapphireCab-YG_R5.glb?v=1600879257',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-SapphireCab_YG_200x200_ad79c266-1f55-48c8-ae6a-c4b84e3e1cc9.png?v=1600879501',
  },
  {
    'sku':        'PR-Seahorse-RG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy_Seahorse-RG_R5.glb?v=1600879258',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Seahorse_RG_200x200_6e714c9b-be38-401b-a9ec-73d5b8352057.png?v=1600879501',
  },
  {
    'sku':        'PR-Beaded-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Beaded-SS_R9.glb?v=1603393715',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Beaded_SS_200x200_ef1e724a-9346-472c-a791-ce1044f97e8e.png?v=1600975869',
  },
  {
    'sku':        'PR-Compass-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Compass-SS_R6.glb?v=1603393716',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/Poesy-Compass_SS_200x200_d6de7d54-7e44-44a0-8511-4432e2e1d341.png?v=1600975869',
  },
  {
    'sku':        'PR-Compass-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Compass-YG_R6.glb?v=1600975530',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/Poesy-Compass_YG_200x200_0e1f4174-b8f0-4465-8a9d-a9960c0dd60b.png?v=1600975870',
  },
  {
    'sku':        'PR-Luck-RG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Luck-RG_R7.glb?v=1600975528',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Luck_RG_200x200_0f673eb3-5045-4cd3-8b41-3792c62bacc1.png?v=1600975869',
  },
  {
    'sku':        'PR-Owl-BLK',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Owl_BLK_R7.glb?v=1600975530',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Owl_R_200x200_3d63c99d-27b4-444f-8156-6fb886233d62.png?v=1600975929',
  },
  {
    'sku':        'PR-Sapphires-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy_Sapphires-SS_R14.glb?v=1603393716',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Sapphires_SS_200x200_1c4d44ba-d844-4f96-9d0b-b6db29d65bea.png?v=1600975870',
  },
  {
    'sku':        'PR-Sapphires-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy_Sapphires-YG_R13.glb?v=1600975530',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Sapphires_YG_200x200_da8d64ac-2141-4fa0-abbd-8fc568e61d5b.png?v=1600975869',
  },
  {
    'sku':        'PR-Seahorse-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy_Seahorse-SS_R6.glb?v=1603393716',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Seahorse_SS_200x200_3e13d163-c01f-4afa-b723-875e16b2b001.png?v=1600975869',
  },
  {
    'sku':        'PR-Happiness-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Happiness-YG_R6.glb?v=1601487885',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR_Happiness_YG_200x200_47acc766-f448-4123-a19d-a35d37170458.png?v=1600975869',
  },
  {
    'sku':        'PR-Eye-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Eye-YG_R8.glb?v=1601488216',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Eye_YG_200x200_3a0bae53-effc-42a3-8db1-9e34fbf4aa22.png?v=1601488689',
  },
  {
    'sku':        'PR-Diamond-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Diamond-YG_R3.glb?v=1601488216',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Diamond_YG_200x200_f7806119-6fd4-4bde-b349-3346165353ee.png?v=1601488689',
  },
  {
    'sku':        'PR-Eye-BLK',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Eye-BLK_R5.glb?v=1601488216',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Eye_BLK_200x200_21d614f4-12dc-4903-8ccb-208afa0a7e77.png?v=1601488689',
  },
  {
    'sku':        'PR-Love-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Love-YG_R3.glb?v=1601488217',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Love_YG_200x200_7019aa2a-290f-47eb-8326-4b73bde6371d.png?v=1601488689',
  },
  {
    'sku':        'PR-Owl-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Owl_YG_R8.glb?v=1601488218',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Owl_YG_200x200_f3ee7ef2-7a0f-4d65-8a19-33182b38a2c8.png?v=1601488689',
  },
  {
    'sku':        'PR-Pave-BLK',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Posey-Pave-BLK_R9.glb?v=1601488218',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Pave_R_200x200_1c47f7c8-0bdb-4044-b580-bea9b8c9165b.png?v=1601488689',
  },
  {
    'sku':        'PR-Pave-WG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Posey-Pave-WG_R10.glb?v=1601488219',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Pave_WG_200x200_4bb37fac-6938-48a1-aae5-4c4cc0044f16.png?v=1601488689',
  },
  {
    'sku':        'PR-Snake-BLK',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Snake-BLK_R10.glb?v=1601488217',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Snake_R_200x200_b345be38-75c5-434f-8e91-27a2e3227478.png?v=1601488689',
  },
  {
    'sku':        'PR-Snake-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Snake-SS_R11.glb?v=1603393716',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Snake_SS_200x200_9bc522ac-ce66-478e-8da4-da6f9069d55d.png?v=1601488689',
  },
  {
    'sku':        'PR-Snake-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy_Snake_YG_R16.glb?v=1601488217',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Snake_YG_200x200_e1da9656-b403-46e9-b549-3c1ea5a73479.png?v=1601488689',
  },
  {
    'sku':        'PR-Carpe-BLK',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Carpe-BLK_R5.glb?v=1601488217',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Carpe_BLK_200x200_4c0a036f-5cfe-4273-a77d-f31276e55de3.png?v=1601488689',
  },
  {
    'sku':        'PR-WhiteSaph-BLK',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-WhiteSaph-BLK_R16.glb?v=1601576232',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Whitesaph_BLK_200x200_0137e67d-e180-4200-a454-aaba8b1c4732.png?v=1601576280',
  },
  {
    'sku':        'PR-Engraved-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Engraved-SS_R8.glb?v=1604421943',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Engraved-ILY_SS_200x200_c733c9d7-51fb-4fd3-a97b-8d4602d91ac8.png?v=1601576280',
  },
  {
    'sku':        'PR-CarpeStripe-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-CarpeStripe-YG_R3.glb?v=1601576231',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CarpeStripe_YG_200x200_6f89b1b3-0d32-4b5f-b8a6-2d3940114ae1.png?v=1601576280',
  },
  {
    'sku':        'PR-CarpeStripe-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-CarpeStripe-SS_R5.glb?v=1603393715',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/CarpeStripe_SS_200x200_32d72497-ad4e-4d0e-81bc-a4934d62f69e.png?v=1601576280',
  },
  {
    'sku':        'PR-Carpe-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-Carpe-YG_R5.glb?v=1601576231',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Carpe_YG_200x200_8ce4b0be-6d68-4e47-b89a-530d603b7c51.png?v=1601576280',
  },
  {
    'sku':        'PR-Buckle-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy-buckle-SS_R11.glb?v=1603393715',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Buckle_SS_200x200_39155b31-c78a-4fa0-a0af-0ab1649bdb27.png?v=1601576280',
  },
  {
    'sku':        'PR-Breathe-YG',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Poesy_Breathe-YG_R4.glb?v=1601576231',
    'type': 'Ring',
    'ghost-image':'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Breathe_YG_200x200_80474716-b4fb-4916-9b96-77ff0663f892.png?v=1601576280',
  },
  {
    'sku':        'CH-41344',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41344_R5.glb?v=1600976091',
    'ghost-image':'',
  },
  {
    'sku':        'PR-010200-Steel-17',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-010200-Steel-17_R4.glb?v=1600878817',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41306',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41306_R6.glb?v=1600878819',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41342',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41342_R8.glb?v=1600878819',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41343',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41343_R18.glb?v=1600878819',
    'ghost-image':'',
  },
  {
    'sku':        'ch-41345',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41345_R3.glb?v=1600878819',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41308',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41308_R4.glb?v=1600456832',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41324',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41324_R5.glb?v=1600456832',
    'ghost-image':'',
  },
  {
    'sku':        'PR-Chain-17-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-17-SS_Short_9a5cf7cd-19d7-47a3-a31b-7280f3e3c324.glb?v=1600456832',
    'ghost-image':'',
  },
  {
    'sku':        'Chain-20035-RG-30',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-20035-RG_R2.glb?v=1600456833',
    'ghost-image':'',
  },
  {
    'sku':        'Chain-20035-WG-30',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-20035-WG_R2.glb?v=1600456832',
    'ghost-image':'',
  },
  {
    'sku':        'PR-Chain-0304-STEELBLACK-32',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-0304-Steel_Black-32_Short.glb?v=1600456833',
    'ghost-image':'',
  },
  {
    'sku':        'PR-Chain-32-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-32-SS_Short.glb?v=1600456833',
    'ghost-image':'',
  },
  {
    'sku':        'PR-NOCHAIN',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-17-SS_Short_Null.glb?v=1638297026',
    'ghost-image':'',
  },
  {
    'sku':        'Chain-0312514-YG-17',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-0312514-YG-17_Short.glb?v=1600456831',
    'ghost-image':'',
  },
  {
    'sku':        'Chain-0312514-RG-17',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-0312514-RG-17_Short.glb?v=1600456831',
    'ghost-image':'',
  },
  {
    'sku':        'Chain-02116-YG-17',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-41115-YG-17_R4.glb?v=1601487666',
    'ghost-image':'',
  },
  {
    'sku':        'Chain-02116-YG-30',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/PR-Chain-41115-YG-30_R4.glb?v=1601487666',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41309',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41309_R4.glb?v=1601487666',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41307',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41307_R10.glb?v=1601487668',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41313',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41313_R4.glb?v=1601487667',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41430',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41430_R10.glb?v=1604441179',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41369',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41369_R7.glb?v=1616611219',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41430-Garnet',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41430-Garnet_R2.glb?v=1616611219',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41464',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41464_R17.glb?v=1616683178',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41371',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41371_R62.glb?v=1629316286',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41486',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41430_R10.glb?v=1613567371',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41527',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41313_R4.glb?v=1601487667',
    'ghost-image':'',
  },
  {
    'sku':        'DYO-NOCHAIN',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41313_null_R14.glb?v=1638297027',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41587',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41587_SS_R6.glb?v=1648048600',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41586',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41586_YG_R4.glb?v=1648048601',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41588',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41588_YG_R1.glb?v=1648048601',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41609-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41609-SS_R1.glb?v=1662123764',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41648-Steel',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41648-BS_R3.glb?v=1662123764',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41648',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41648-YG_R3.glb?v=1662123764',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41464-SS',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41464-SS_R7.glb?v=1676860577',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41430-Turq',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/CH-Chain-41430-Turq_R7.glb?v=1676860577',
    'ghost-image':'',
  },
  {
    'sku':        'CH-41576',
    'model-file': 'https://cdn.shopify.com/s/files/1/2143/1049/files/Chain-CH-41324_R5.glb?v=1600456832',
    'ghost-image':'',
  },
];